import Vue from 'vue';
import toastV2 from '../components/ui/toast-v2/index';

Vue.use(toastV2);
